import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'

import { gridSetOperationError } from 'actions/grid'
import Modal from 'components/modal'
import { getOperationError } from 'selectors/grid'

import GridErrorModal from './grid-error-modal'

class GridErrorModalContainer extends Component {

  constructor(props) {
    super(props)

    this.closeModal = this.closeModal.bind(this)
  }

  closeModal() {
    this.props.gridSetOperationError(null)
  }

  render() {
    return (
      <Modal light wide closeModal={this.closeModal} isOpen={!!this.props.operationError}>
        <GridErrorModal message={this.props.operationError} closeModal={this.closeModal} />
      </Modal>
    )
  }
}

GridErrorModalContainer.propTypes = {
  gridSetOperationError: PropTypes.func.isRequired,
  operationError: PropTypes.string,
}

const mapStateToProps = state => ({
  operationError: getOperationError(state),
})

const mapDispatchToProps = { gridSetOperationError }

export default connect(mapStateToProps, mapDispatchToProps)(GridErrorModalContainer)



/** WEBPACK FOOTER **
 ** ./src/components/grid-error-modal/grid-error-modal-container.js
 **/